import styled from 'styled-components';
import { get } from '../../constants.js';

const Body = styled.div.withConfig({
  displayName: "styles__Body",
  componentId: "sc-o6cxtw-0"
})(["display:flex;flex-direction:column;list-style:none;margin:0;padding:0;> * + *{margin-top:", ";}"], get('space.2'));

export { Body };
